module.exports = __webpack_public_path__ + "static/media/1.f054d570.jpg";